export enum I18nNamespace {
    ALERT_RULES = 'alert-rules',
    AUTH = 'auth',
    CAMERAS = 'cameras',
    COMMON = 'common',
    DIRECTORY = 'directory',
    EVENTS = 'events',
    HOME = 'home',
    QUERIES = 'queries',
    REPORTS = 'reports',
    SETTINGS = 'settings',
    SETUP_HDMI = 'setup-hdmi',
    SOURCES = 'sources',
    VIDEO = 'video',
}
